import type { SocialPost } from './types';

export const RESERVED_SOCIAL_HANDLES = new Set(['site', 'studio', 'api', 'auth', '_next', 'home', 'post', 'profile', 'search', 'explore', 'create', 'login', 'signup', 'settings', 'sessions', 'docs', 'notifications', 'bookmarks', 'messages', 'boards', 'archive', 'connected-sites', 'demo', 'oauth', 'site-oauth-callback', 'reference', 'reference-assets', '_mintlify', 'favicons']);

export function socialProfilePath(handle: string): string {
  return `/${encodeURIComponent(handle)}`;
}

export function isSocialProfilePath(pathname: string): boolean {
  const match = pathname.match(/^\/([a-z0-9_]{3,30})(?:\/([a-z0-9][a-z0-9-]{0,39}))?\/?$/);
  return Boolean(match && !RESERVED_SOCIAL_HANDLES.has(match[1]) && match[2] !== 'post');
}

export function socialPostPath(post: Pick<SocialPost, 'id' | 'publicId' | 'author'>): string {
  return post.publicId && /^\d{11}$/.test(post.publicId)
    ? `/${encodeURIComponent(post.author.handle)}/post/${post.publicId}`
    : `/post/${encodeURIComponent(post.id)}`;
}
